import script from "./FeeReceiptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FeeReceiptModal.vue?vue&type=script&setup=true&lang=js"

import "./FeeReceiptModal.vue?vue&type=style&index=0&id=3172e3b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3172e3b0"]])

export default __exports__